/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CompactViewNotes/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function CompactViewNotes({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard/Content/Content/CompactViewNotes",
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let settingsDataCompactViewNotesValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.compact_view_notes',
})
let settingsDataCompactViewNotesChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.compact_view_notes',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 allowEmptyChoice={false}
 data="options"
 from={optionsValueData}
 data="settings.data.compact_view_notes"
 onChange={settingsDataCompactViewNotesChangeData}
 value={settingsDataCompactViewNotesValueData}
 maxWidth={300}
 marginRight={dtSpaceXs}
 flexGrow={0}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="When compact view is on, display notes"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}